import React from "react";

const TextArea = props => (
  <div className="form-group">
    {props.title !== '' ? <label htmlFor={props.name} className="uxf-label"> {props.title} </label> : ""}
    <textarea
      name={props.name}
      rows={props.rows}
      cols={props.cols}
      value={props.value}
      className={"form-control " + props.class}
      tabIndex={props.tabIndex}
      onChange={props.handleChange}
      maxLength={props.maxLength}
      placeholder={props.placeholder}
    />
  </div>
);

export default TextArea;
